import * as React from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { APP_QUERY } from 'const/queries';
import { PRICE_PLAN_UPDATE, PRICE_PLAN_DELETE } from 'const/mutations';
import { PricePlanFormView } from './view';

export function PricePlanEditForm() {
    const navigate = useNavigate();
    const { id: appId, pid: planId } = useParams<{ id: string; pid: string }>();
    const DASHBOARD_LINK = '/extranet/apps/' + appId + '/dashboard';

    const { data } = useQuery(APP_QUERY, { variables: { id: appId } });
    const app = data && data.app;
    const plan = data && data.app.pricePlans.find(p => p.id.toString() === planId.toString());

    const [planUpdate, { loading: saving }] = useMutation(PRICE_PLAN_UPDATE, {
        onCompleted() {
            navigate(DASHBOARD_LINK);
        },
    });

    const [planDelete, { loading: deleting }] = useMutation(PRICE_PLAN_DELETE, {
        onCompleted() {
            navigate(DASHBOARD_LINK);
        },
    });

    const onSubmit = (values, form, callback) => {
        planUpdate({ variables: values })
            .then(() => callback())
            .catch(err => callback(err));
    };

    const onDelete = () => {
        planDelete({ variables: { id: planId } });
    };

    const onCancel = () => {
        navigate(DASHBOARD_LINK);
    };

    const isDisabled =
        !app || !app.status || app.status === 'PUBLISHED' || app.status === 'IN_REVIEW';

    return (
        <PricePlanFormView
            app={app}
            plan={plan}
            loading={saving}
            deleting={deleting}
            disabled={isDisabled}
            onCancel={onCancel}
            onSubmit={onSubmit}
            onDelete={onDelete}
        />
    );
}
